
        window.getEnvironmentFromURL = () => 'staging'
        window.__URI__ = () => 'wss://staging.signaling.aire.link/s1/jsonrpc'
      